import React from "react";
import LoginForm from "../../widgets/login/Login";

function Login(props) {
  return (
    <>
      <LoginForm />
    </>
  );
}

export default Login;
